module.exports = __webpack_public_path__ + "fonts/Pecita.71eb605b.otf";